/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SelfCheckinRoles {
  SelfCheckin = 'self_checkin'
}
